export default class control {
  constructor(el) {
    this.el = el
    this.canScrollX = false
    this.canScrollY = false
    this.curX = 0
    this.curY = 0
    this.preX = 0
    this.preY = 0
    this.addEvent()
  }
  addEvent() {
    this.addTouchStart()
    this.addTouchMove()
    this.addTouchEnd()
  }
  addTouchStart() {
    this.el.addEventListener(
      'touchstart',
      (e) => {
        this.bindTouchStart(e)
      },
      { passive: false }
    )
  }
  bindTouchStart(e) {
    //可以左右滚动
    this.canScrollX = this.el.scrollWidth > this.el.clientWidth
    //可以上下滚动
    this.canScrollY = this.el.scrollHeight > this.el.clientHeight
    this.curX = e.touches[0].pageX
    this.curY = e.touches[0].pageY
    this.preX = e.touches[0].pageX
    this.preY = e.touches[0].pageY
  }
  addTouchMove() {
    this.el.addEventListener(
      'touchmove',
      (e) => {
        this.bindTouchMove(e)
      },
      {
        passive: false
      }
    )
  }
  bindTouchMove(e) {
    this.curX = e.changedTouches[0].pageX
    this.curY = e.changedTouches[0].pageY
    if (this.canScrollX) {
      if (this.curX < this.prex) {
        this.isToRight() && e.preventDefault()
      } else {
        this.isToLeft() && e.preventDefault()
      }
    }
    if (this.canScrollY) {
      if (this.curY < this.preY) {
        this.isToBottom() && e.preventDefault()
      } else {
        this.isToTop() && e.preventDefault()
      }
    }
  }
  addTouchEnd() {
    this.el.addEventListener(
      'touchend',
      (e) => {
        this.bindTouchEnd(e)
      },
      {
        passive: false
      }
    )
  }
  bindTouchEnd() {}
  removeEvent() {
    this.el.removeEventListener('touchstart', this.bindTouchStart, {
      passive: false
    })
    this.el.removeEventListener('touchsmove', this.bindTouchMove, {
      passive: false
    })
    this.el.removeEventListener('touchend', this.bindTouchEnd, {
      passive: false
    })
  }
  isToLeft() {
    return this.el.scrollLeft <= 0
  }
  isToRight() {
    return this.el.scrollLeft >= this.el.scrollWidth - this.el.offsetWidth
  }
  //到底了
  isToBottom() {
    return this.el.scrollTop >= this.el.scrollHeight - this.el.offsetHeight
  }
  // 到顶部了
  isToTop() {
    return this.el.scrollTop <= 0
  }
}
